import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useBranchList = () => {
  return useQuery({
    queryKey: ["branchListState"],
    queryFn: async () =>
      callApi({
        path: "branchlist",
        command: "",
        data: "{}",
      }),
  });
};
